import { BsResourceManagementPageHeaderTab } from './BsResourceManagementPageHeaderTab';
export default BsResourceManagementPageHeaderTab;
